/**
 * @flow
 * @relayHash 4f5ca716131fa3f0728aa9b5d213082f
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type SearchContainer_viewer$ref = any;
export type SearchContainerRefetchQueryVariables = {|
  query: string
|};
export type SearchContainerRefetchQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: SearchContainer_viewer$ref
  |}
|};
export type SearchContainerRefetchQuery = {|
  variables: SearchContainerRefetchQueryVariables,
  response: SearchContainerRefetchQueryResponse,
|};
*/


/*
query SearchContainerRefetchQuery(
  $query: String!
) {
  viewer {
    ...SearchContainer_viewer_1Qr5xf
    id
  }
}

fragment SearchContainer_viewer_1Qr5xf on User {
  s_time_zone
  user_event_search(first: 3, query: $query) {
    edges {
      node {
        event {
          id
          title
        }
        booking_status
        start_at
        end_at
        user_event_segments(first: 1) {
          edges {
            node {
              location
              id
            }
          }
        }
        id
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "query",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "SearchContainerRefetchQuery",
  "id": null,
  "text": "query SearchContainerRefetchQuery(\n  $query: String!\n) {\n  viewer {\n    ...SearchContainer_viewer_1Qr5xf\n    id\n  }\n}\n\nfragment SearchContainer_viewer_1Qr5xf on User {\n  s_time_zone\n  user_event_search(first: 3, query: $query) {\n    edges {\n      node {\n        event {\n          id\n          title\n        }\n        booking_status\n        start_at\n        end_at\n        user_event_segments(first: 1) {\n          edges {\n            node {\n              location\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "SearchContainerRefetchQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "SearchContainer_viewer",
            "args": [
              {
                "kind": "Variable",
                "name": "query",
                "variableName": "query",
                "type": null
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "SearchContainerRefetchQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "s_time_zone",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user_event_search",
            "storageKey": null,
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 3,
                "type": "Int"
              },
              {
                "kind": "Variable",
                "name": "query",
                "variableName": "query",
                "type": "String!"
              }
            ],
            "concreteType": "UserEventConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "UserEventEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserEvent",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "event",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Event",
                        "plural": false,
                        "selections": [
                          v1,
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "title",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "booking_status",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "start_at",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "end_at",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "user_event_segments",
                        "storageKey": "user_event_segments(first:1)",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "first",
                            "value": 1,
                            "type": "Int"
                          }
                        ],
                        "concreteType": "UserEventSegmentConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "UserEventSegmentEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "UserEventSegment",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "location",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  v1
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      v1
                    ]
                  }
                ]
              }
            ]
          },
          v1
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '59fc8930bad017ad22a4ca5971020d97';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/components/App/__generated__/SearchContainerRefetchQuery.graphql.js